import React, { memo, useMemo } from 'react'
import { Chip } from 'src/components/shared/Chip'
import { colors } from 'src/theme'
import tw from 'twin.macro'
import dayjs from 'dayjs'
import { addS } from 'src/utils/baseUtils'

interface Props {
  expiresAt: string
}

const getInviteChipParams = (expiresAt: string) => {
  const now = dayjs()
  const expiry = dayjs(expiresAt)

  const diffDays = expiry.diff(now, 'day', true)
  const daysLeft = Math.round(diffDays)

  if (diffDays < 0) {
    return {
      color: colors.COLORS_RED_500,
      text: 'Expired',
      bgStyle: tw`bg-[#FFE8EE]`,
    }
  }

  if (daysLeft === 0) {
    return {
      color: colors.COLORS_ORANGE_500,
      text: 'Expires today',
      bgStyle: tw`bg-[#FFEED6]`,
    }
  }

  if (daysLeft < 4) {
    return {
      color: colors.COLORS_ORANGE_500,
      text: `${daysLeft} ${addS(daysLeft, 'day')}`,
      bgStyle: tw`bg-[#FFEED6]`,
    }
  }

  return {
    color: colors.COLORS_BLUE_500,
    text: `${daysLeft} ${addS(daysLeft, 'day')}`,
    bgStyle: tw`bg-[#D8E5FF]`,
  }
}

const ExpiresInviteChipComponent = ({ expiresAt }: Props) => {
  const params = useMemo(() => getInviteChipParams(expiresAt), [expiresAt])

  return (
    <div css={tw`flex items-center`}>
      <div css={tw`py-1 rounded-[10px]`}>
        <Chip className={params.bgStyle} textColor={params.color} text={params.text} />
      </div>
    </div>
  )
}

export const ExpiresInviteChip = memo(ExpiresInviteChipComponent)
